import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; 
import Home from "./Home";
import About from "./About"
import CallForAbstracts from "./Abstracts";
import Program from "./Program"
// import VenueAndRegistration from "./VenueAndRegistration";
// import ScheduleOfEvents from "./ScheduleOfEvents";
// import ScientificProgram from "./ScientificProgram";
import Sponsorship from "./Sponsorship";
import Sponsors from "./Sponsors";
import AboutIWPFI from "./AboutIWPFI";
import BoardMembers from "./BoardMembers";
import Registration from "./Registration";
import Accommodation from "./Accommodation";
// import OrganizationalCommittee from "./OrganizationalCommittee";


function App() {
  return (
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/About" element={<About />} />
      <Route path="/CallForAbstracts" element={<CallForAbstracts />} />
      <Route path="/Program" element={<Program />} />
      {/* <Route path="/VenueAndRegistration" element={<VenueAndRegistration />} /> */}
      {/* <Route path="/ScheduleOfEvents" element={<ScheduleOfEvents />} />
      <Route path="/ScientificProgram" element={<ScientificProgram />} /> */}
      <Route path="/Sponsorship" element={<Sponsorship />} />
      <Route path="/Sponsors" element={<Sponsors />} />
      <Route path="/AboutIWPFI" element={<AboutIWPFI />} />
      <Route path="/BoardMembers" element={<BoardMembers />} />
      <Route path="/Registration" element={<Registration />} />
      <Route path="/Accommodation" element={<Accommodation />} />
      {/* <Route path="/OrganizationalCommittee" element={<OrganizationalCommittee />} /> */}
    </Routes>
  </Router>
  );
}

export default App;